import { ReelAnimationController } from "./ReelAnimationController";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";

export class ReelAnimationManager extends BaseView{

    private static _instance:ReelAnimationManager;
    private _allReelAreas:ReelAnimationController[] = [];

    private _bonusReelID:number = 5;

    public static get instance():ReelAnimationManager{
        return this._instance;
    }
    public static get bonusReelID():number{
        return this.instance._bonusReelID;
    }

    public static get bonusReel():ReelAnimationController{
        return this.instance._allReelAreas[this.instance._bonusReelID];
    }

    public static getReelArea(id:number):ReelAnimationController{
        return this.instance._allReelAreas[id];
    }

    constructor(){
        super();
        if(!ReelAnimationManager._instance){
            ReelAnimationManager._instance = this;
            StageManager.getLayer(PunkGameConfig.instance.LAYERS.REEL_OVERLAY.name).addChild(this);
        } 
    }

    protected initAnimations():void{
        for(let id:number = 0; id < PunkGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT;id++){
            const temp:ReelAnimationController = new ReelAnimationController(id);
            this._allReelAreas.push(temp);
            this.addChild(temp);
        }
        ReelAnimationManager.bonusReel.setActiveReel(false);
        this.onResize();
    }

    protected onResize(){
        this._allReelAreas.forEach(area => { area.onResize();});
    }
}